import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["textAlign", "renderLabel", "renderValue", "isGroupChild"];
var _dec, _class, _Metric;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { withStyle } from '@instructure/emotion';
import { callRenderProp, passthroughProps } from '@instructure/ui-react-utils';
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
let Metric = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Metric = class Metric extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    var _this$props$styles, _this$props$styles2, _this$props$styles3;
    const _this$props3 = this.props,
      textAlign = _this$props3.textAlign,
      renderLabel = _this$props3.renderLabel,
      renderValue = _this$props3.renderValue,
      isGroupChild = _this$props3.isGroupChild,
      rest = _objectWithoutProperties(_this$props3, _excluded);
    return _jsxs("div", {
      ...passthroughProps(rest),
      role: isGroupChild ? 'row' : void 0,
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.metric,
      ref: this.handleRef,
      "data-cid": "Metric",
      children: [_jsx("div", {
        role: isGroupChild ? 'rowheader' : void 0,
        css: (_this$props$styles2 = this.props.styles) === null || _this$props$styles2 === void 0 ? void 0 : _this$props$styles2.label,
        children: callRenderProp(renderLabel)
      }), _jsx("div", {
        role: isGroupChild ? 'gridcell' : void 0,
        css: (_this$props$styles3 = this.props.styles) === null || _this$props$styles3 === void 0 ? void 0 : _this$props$styles3.value,
        children: callRenderProp(renderValue)
      })]
    });
  }
}, _Metric.displayName = "Metric", _Metric.componentId = 'Metric', _Metric.allowedProps = allowedProps, _Metric.defaultProps = {
  textAlign: 'center',
  isGroupChild: false
}, _Metric)) || _class);
export default Metric;
export { Metric };